module.exports = __webpack_public_path__ + "static/media/campaing.9a197839.jpeg";